import { HStack, Text } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';

type IProps = {
  onSignUpClick: Dispatch<SetStateAction<boolean>>;
};

const DesktopSignUp: React.FC<IProps> = (props: IProps) => (
  <HStack
    spacing={2}
    cursor="pointer"
    bg={'icon.green'}
    px={4}
    py={2}
    borderRadius="8px"
    onClick={(e) => props.onSignUpClick(true)}
    display={{ base: 'none', lg: 'flex' }}>
    <Text
      color="white"
      fontWeight="semibold"
      fontSize="16px"
      fontFamily="marketingPage"
      whiteSpace="nowrap">
      Sign Up
    </Text>
  </HStack>
);

export default DesktopSignUp;
